import { render, staticRenderFns } from "./editCatalog.vue?vue&type=template&id=7b60b42f&scoped=true"
import script from "./editCatalog.vue?vue&type=script&lang=js"
export * from "./editCatalog.vue?vue&type=script&lang=js"
import style0 from "./editCatalog.vue?vue&type=style&index=0&id=7b60b42f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b60b42f",
  null
  
)

export default component.exports